/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import { Grid, MenuItem, FormControl, Select, InputLabel, Input, Checkbox, ListItemText } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { convertToArray } from '../../../helpers/pricing';

const styles = makeStyles({
  formControl: {
    width: '140px',
  },
  splitContainer: {
    marginTop: '15px',
  },
});

const CustomSplit = props => {
  const { group, handleGroupAttrEdit, quantity } = props;
  const classes = styles();
  const quantityArray = quantity && quantity.length > 0 ? quantity.sort((a, b) => a - b) : [];

  const getCustomSplit = () => {
    if (group.custom_split) {
      return convertToArray(group.custom_split, quantityArray);
    }
    if (group.ranks && group.ranks.length > 0 && group.ranks[0]) {
      const custom = group.ranks[0].custom_split;
      return convertToArray(custom, quantityArray);
    }
    return null;
  };

  const customSplit = getCustomSplit();

  return (
    <>
      <Grid item xs={12} className={classes.splitContainer}>
        <FormControl className={classes.formControl} error={quantityArray.length === 0}>
          <InputLabel shrink htmlFor="age-simple">
            Custom Split
          </InputLabel>

          <Select
            multiple
            value={customSplit}
            onChange={handleGroupAttrEdit('custom_split', null)}
            input={<Input width={100} id="select-multiple-custom-splits" />}
            renderValue={selected => selected.sort((a, b) => a - b).join(', ')}
          >
            {quantityArray.map(split => (
              <MenuItem key={split} value={split}>
                <Checkbox checked={customSplit.indexOf(split) > -1} />
                <ListItemText primary={split} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </>
  );
};

CustomSplit.propTypes = {
  group: PropTypes.object.isRequired,
  handleGroupAttrEdit: PropTypes.func.isRequired,
  quantity: PropTypes.array.isRequired,
};

export default CustomSplit;
